module.exports = __webpack_public_path__ + "img/56-white.8d726c6c.svg";